export default [
  [`Размеры`, `S`, `M`, `L`, `XL`],
  [`Российский размер`, `44-46`, `46-48`, `48-50`, `50-52`]
];
